import React from 'react';
import styles from './index.module.scss';

interface StepThreeProps {
  fontColor?: string;
}

export const StepThree: React.FC<StepThreeProps> = ({ fontColor }) => (
  <div className={styles.StepThree}>
    <h3 style={{ color: fontColor }}>Thank You!</h3>
    <p style={{ color: fontColor }}>
      Thanks for registering your details.
      <br />
      We&apos;ll be in touch soon with all the latest from Subaru.
      <br />
      Meanwhile, learn more about <a href="/">Subaru</a>.
    </p>
  </div>
);
